import { render } from "./BomCellPartNumber.vue?vue&type=template&id=0bcef8bb&scoped=true"
import script from "./BomCellPartNumber.vue?vue&type=script&lang=js"
export * from "./BomCellPartNumber.vue?vue&type=script&lang=js"

import "./BomCellPartNumber.vue?vue&type=style&index=0&id=0bcef8bb&scoped=true&lang=css"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bcef8bb"]])

export default __exports__